export default "__VITE_ASSET__21d429e1__"